var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exchange-wrapper"},[_c('tiga-notice'),_c('div',{class:['exchange-container', _vm.isShowDetail ? 'next' : '']},[_c('div',{staticClass:"content-item"},[_c('exchange-page',{ref:"exchange"})],1),_c('div',{staticClass:"content-item"},[(_vm.isShowDetail)?_c('take-order',{attrs:{"id":_vm.orderId}}):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }